module.exports = __webpack_public_path__ + "static/media/sms.c5a393f3.svg";